import request from "@/utils/request";


export function feedbackDialog(){
    return request({
        baseURL: '@BaseUrl',
        url:'/api/issue',
        method:'GET'
    })
}

export function feedbackListUpdate(
  submissionId: number,
  data: {
    tag: string
    resolver: string
    resolveTime: string
  }
) {
  return request({
    baseURL: '@BaseUrl',
    url: `/api/issueListUpdate/${submissionId}`,
    method: 'PUT',
    data
  })
}

